export const TOOLTIP_IN_HOVER = "TOOLTIP_IN_HOVER"
interface tooltipInHoverAction {
	type: typeof TOOLTIP_IN_HOVER
	payload: string
}


export type tooltipActionTypes = tooltipInHoverAction
